<template>
  <div>
    <AccountSettingsSecuritySettings v-if="$auth.user && $auth.user.securitySection.show" />
    <template v-if="isFlutterReady">
      <div class="text-h2 mt-6 mb-4">
        {{ $t('profile.appSecurity') }}
      </div>
      <MobileButtonGroup :buttons="buttons" />
    </template>
    <template v-else-if="isBiometryAvailable && !biometryCheckBusy">
      <div class="text-h2 mt-6 mb-4">
        {{ $t('profile.cAppSecurity.title') }}
      </div>
      <v-row no-gutters align="center" class="py-0 py-md-4">
        <v-col class="d-flex flex-column">
          <div class="text-h3">
            {{ $t('profile.cAppSecurity.biometry.title') }}
          </div>
          <div class="text-body-small grey-darken-1--text">
            {{ $t('profile.cAppSecurity.biometry.description') }}
          </div>
        </v-col>
        <v-col class="flex-shrink-1 flex-grow-0 ml-4">
          <v-switch
            :input-value="biometryEnabled"
            hide-details
            inset
            color="success"
            :loading="biometryAuthBusy"
            :disabled="biometryAuthBusy"
            @click="sendGtmEvent('Přepnutí biometrického zámku')"
            @change="toggleBiometry"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import AccountSettingsAccountSettingsSecuritySettings from '@/components/Molecules/AccountSettings/AccountSettingsSecuritySettings.vue';
import { Capacitor } from '@capacitor/core';
import { useCapacitorStorage } from '@/composables/capacitor/useCapacitorStorage.ts';
import { useCapacitorBiometry } from '@/composables/capacitor/useCapacitorBiometry.ts';

export default {
  name: 'SecuritySettings',
  components: {
    AccountSettingsSecuritySettings: AccountSettingsAccountSettingsSecuritySettings
  },
  data() {
    return {
      biometryCheckBusy: true,
      biometryAuthBusy: false,
      isBiometryAvailable: false,
      biometryEnabled: false
    };
  },
  computed: {
    buttons() {
      return [
        {
          img: 'lock',
          text: this.$t('profile.applicationLock'),
          click: () => {
            if (this.isFlutterReady) {
              window.flutter_inappwebview.callHandler('openPinSettings');
            }
          }
        }
      ];
    },
    isFlutter() {
      return !!window.flutter_inappwebview;
    }
  },
  async mounted() {
    if (Capacitor.isNativePlatform()) {
      const { getValue } = useCapacitorStorage();
      try {
        const [biometryAvailable, biometryEnabled] = await Promise.all([
          getValue('biometryAvailable'),
          getValue('biometryEnabled')
        ]);
        this.isBiometryAvailable = biometryAvailable === 'true';
        this.biometryEnabled = biometryEnabled === 'true';
      } catch (error) {
        this.handleError({ error, code: '0x00000009' });
      }
    }

    this.biometryCheckBusy = false;
  },
  methods: {
    async toggleBiometry(newValue) {
      if (this.biometryAuthBusy) {
        return;
      }
      this.biometryAuthBusy = true;

      try {
        const { authenticate } = useCapacitorBiometry();
        await authenticate();

        const { setValue } = useCapacitorStorage();
        await setValue('biometryEnabled', `${newValue}`);
        this.biometryEnabled = newValue;
      } catch (error) {
        this.handleError({ error, code: '0x0000004E' });
      } finally {
        this.biometryAuthBusy = false;
      }
    }
  }
};
</script>
